import React from "react"
import {Wave} from "react-css-spinners"

const FullScreenCenteredLoading = () => {
    return (
        <div>
            <Wave
                color="#00425A"
                style={{
                    position: "fixed",
                    zIndex: 999,
                    overflow: "show",
                    margin: "auto",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                }}
            />
        </div>
    )
}

export default FullScreenCenteredLoading
